import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Timesheet from "../Components/timesheet";  // Import your Timesheet component
import { Typography, Button } from "@mui/material";
import RestartAltIcon from '@material-ui/icons/RestartAlt';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%', padding: '32px 16px 32px 16px' }}>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          paddingRight: '16px'
        }}>

        <Typography color="textPrimary" variant="h3">
          Tempo
        </Typography>
        <Button
          variant="contained"
          color="secondary"
          // onClick={handleResetFilters}
          title="Reset to defaults"
          sx={{
            minWidth: '50px',
            ml: 1,

          }}>
          Export
          {/* <RestartAltIcon /> */}
        </Button>


      </Box>

      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab label="Timesheet" {...a11yProps(0)} />
          <Tab label="Graphs" {...a11yProps(1)} />
          {/* <Tab label="Item Three" {...a11yProps(2)} /> */}
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <Timesheet />  {/* Add Timesheet here */}
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        Graphs
      </CustomTabPanel>
      {/* <CustomTabPanel value={value} index={2}>
        Item Three
      </CustomTabPanel> */}
    </Box>
  );
}
